import React from "react";

const formatCurrency = (
	amount: number,
	currency = "AUD",
	minimumFractionDigits = 4,
	maximumFractionDigits = 4
) => {
	const formattedAmount = new Intl.NumberFormat(
		`en-${currency === "USD" ? "US" : "AU"}`,
		{
			style: "currency",
			currency: currency,
			minimumFractionDigits,
			maximumFractionDigits,
		}
	).format(amount);

	// Prepend "A$" only for AUD
	return currency === "AUD" ? `A${formattedAmount}` : formattedAmount;
};

// Example usage in a React component
const CurrencyDisplay: React.FC<{
	amount: number;
	currency?: string;
	minimumFractionDigits?: number;
	maximumFractionDigits?: number;
}> = ({
	amount,
	currency = "USD",
	minimumFractionDigits = 2,
	maximumFractionDigits = 2,
}) => {
	return (
		<span className="font-code font-semibold text-xl text-center">
			{formatCurrency(
				amount,
				currency,
				minimumFractionDigits,
				maximumFractionDigits
			)}
		</span>
	);
};

export default CurrencyDisplay;
